/**
 *
 * key
 *
 */

 const key = 'bmV3VW5hc3NpZ25lZExlYWQ='

 export default key
 